/**
 * Router
 * 
 * 
 */
import store from '../../../api/store'

const Router = {};

// 注册Router
Router.install = function (Vue) {
    

    // 通过Vue的原型注册一个方法
    // 让所有实例共享这个方法 
    Vue.prototype.$routerPush = ($e, url) => {
        $e.$router.push({
            path: url,
            query: {
                shareToken: store.loginedUser.shareToken
            }
        })
    }

    Vue.prototype.$routerReplace = ($e, url) => {
        $e.$router.replace({
            path: url,
            query: {
                shareToken: store.loginedUser.shareToken
            }
        })
    }
}

export default Router


// WEBPACK FOOTER //
// ./src/components/global/router/index.js